import { Routes, Route, useNavigate } from "react-router-dom";
import { UserAuthContextProvider } from "./UserAuthContext";
import Survey from "./Routes/survey/survey";
import Game from "./Routes/game/game";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "./index.css";
import { useEffect } from "react";
import Layout from "./Helpers/layout";
import ReactGA from 'react-ga4';
import Privacy from "./Routes/privacy/privacy";
import { useLocation } from "react-router-dom";
import Dashboard from "./Routes/profile/Dashboard";
import NewHome from "./Routes/home/NewHome";
import LearnMore from "./Routes/home/LearnMore";

ReactGA.initialize('G-Q57YBER85X');


// Send pageview with a custom path
function Redirect() {
  const navigate = useNavigate();
  // Add this code block to handle any unknown routes and redirect to the home page.
  useEffect(() => {
    navigate("/", { replace: true });
  }, [navigate]);

  return <></>;
}

function App() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({top: 0, left: 0, behavior: "instant"});

    //Send a pageview to Google Analytics whenever the route changes
    ReactGA.send({ hitType: "pageview", page: pathname });
  }, [pathname]);

  return (
    <UserAuthContextProvider>
      <Routes>
        {/* A common layout for all the pages */}
        <Route path="/" element={<Layout />}>
          <Route path="/home" element={<NewHome />} />
          <Route path="/learn-more" element={<LearnMore /> } />
          <Route path="/survey" element={<Survey />} />
          <Route index element={<Game />} />
          <Route path="/privacy-policy" element={<Privacy />}/>
          <Route path="*" element={<Redirect />} />
          <Route path="/profile-dashboard" element={<Dashboard />}/>
        </Route>
      </Routes>
    </UserAuthContextProvider>
  );
}

export default App;
